package com.nonopn.skywatcher.design.widgets

import androidx.compose.material.OutlinedTextField
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.input.TextFieldValue
import com.nonopn.skywatcher.design.res.Res
import com.nonopn.skywatcher.design.res.cancel
import com.nonopn.skywatcher.design.res.validate
import com.nonopn.skywatcher.design.utils.localized
import eu.codlab.compose.widgets.TextNormal

@Suppress("LongMethod")
@Composable
fun PromptDialog(
    title: String,
    text: String,
    onDismiss: () -> Unit,
    onConfirm: (String) -> Unit
) {
    var deckName by remember { mutableStateOf(TextFieldValue("")) }

    PopupConfirm(
        "hardcoded",
        title = title,
        text = text,
        alternateText = {
            OutlinedTextField(
                value = deckName,
                onValueChange = {
                    deckName = it
                },
                label = {
                    TextNormal(
                        color = Color.Black,
                        text = title
                    )
                }
            )
        },
        onDismiss = onDismiss,
        actions = listOf(
            PopupConfirmAction(
                text = Res.string.cancel.localized(),
                isOutlined = false,
                onClick = { onDismiss() }
            ),
            PopupConfirmAction(
                text = Res.string.validate.localized(),
                isOutlined = true,
                onClick = {
                    onConfirm(deckName.text)
                }
            )
        )
    )
}
